import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  props: {
    cards: {
      type: Array,
      required: true,
    },
  },
  mixins: [dynamicLocalization],
};
